import { FileDown, Loader2 } from "lucide-react";
import { useCallback, useState } from "react";
import { usePaperCitationsApi } from "../../api/citations";
import { useCitations } from "../../context/CitationProvider";
import { useChatSession } from "../../context/ChatSessionProvider";
import { enrichCitations } from "../../utils/citationFormat";
import { ActionButton } from "./ActionButton";

export const SaveSessionButton = () => {
  const [saving, setSaving] = useState(false);
  const { messages } = useChatSession();
  const { citations } = useCitations();
  const { fetchCitationMetadata } = usePaperCitationsApi();

  const handleSave = useCallback(async () => {
    setSaving(true);
    try {
      const enriched = await enrichCitations(citations, fetchCitationMetadata);
      const { exportSessionAsHtml } = await import("../../utils/exportSession");
      exportSessionAsHtml(messages, enriched);
    } catch (err) {
      console.error("Failed to save session:", err);
    } finally {
      setSaving(false);
    }
  }, [messages, citations, fetchCitationMetadata]);

  return (
    <ActionButton
      label={saving ? "Saving…" : "Save session"}
      onClick={handleSave}
      disabled={saving}
    >
      {saving ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <FileDown className="h-3.5 w-3.5" />
      )}
    </ActionButton>
  );
};
